<script> 
import apigeneric from "@/helpers/apigeneric";
export default { 
  mixins: [ apigeneric],
  data() {
    return { 
        NoticesData:{},
        NoticesTitle: {},
        ActiveNotices: [],
        showNoticesModal: false,
        NoticesTitleDescription: {},
        ReadMoreValue: {},
        DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    };
  },
  components: { 
   
  }, 
  methods: { 
    Get(){
        let Page = {
      PageNumber: "1",
      PageSize: "8",
      PageDataSize: "1", 
    };
        this.ActionsFilterGet({
        Service: "News",
        Page: Page,
        Filter:"&Desc=Startdate&Newstype=1&Websiteid="+window.$cookies.get("ecampuswebsite"),
      }).then((res) => {
        this.NoticesData = res.Data; 

        console.log(JSON.stringify( this.NoticesData))

          this.ActiveNotices = this.NoticesData.filter(x => x.Islightbox);

        if (this.ActiveNotices.length > 0) {
          this.showNoticesModal = true;
        }

      });

      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.localStorage.getItem("lang")
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=215b4e3e-250f-4ebd-bf96-f04aec90de20"
          }).then((res) => {
            this.NoticesTitle = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });


      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.localStorage.getItem("lang")
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=19269e1f-b2fe-4ea9-9a2b-4c5cd91d2266"
          }).then((res) => {
            this.NoticesTitleDescription = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });

     

    }
  },
};
</script>

<template> 
       
    <section>
        <div class="notices">
            <div class="title c-flex flex-column">
                <a :href="'/fullnotices/tr'" class="card-link"><h3>{{$t("dashboards.NoticesTitle")}}</h3></a>
                <p>{{$t("dashboards.NoticesDescription")}}</p>
            </div> 
            <div class="container">
                <div class="row">
              
                        <div class="col-md-6 mb-5"  v-for="Data in NoticesData" :key="Data.Id">
                          <div class="notice-item">
                            <div class="row">
                                <div class="col-md-5 ">
                                    <img :src="$config.FILES_URL + 'web/' + Data.Imagegallery" alt="" />
                                </div>
                                <div class="col-md-7 d-flex justify-content-between flex-column">
                                    <p class="head">{{Data.Title}}</p>
                                    <p class="date">{{Data.Startdate | formatDateTime }}</p>
                                    <p class="content">
                                         <span v-html="Data.Description"></span><br />
                                    </p>
                                    <a :href="'/NewsDetail/tr/'+ Data.Title.toLowerCase()
                                    .replace(/I|İ/gi, 'i')
                                    .replace(/Ğ|ğ/gi, 'g')
                                    .replace(/Ç|ç|ğ/gi, 'c')
                                    .replace(/\s+/g, '-')
                                    .replace(/&/g, `-and-`)
                                    .replace(/--/g, `-`) + '/' + Data.Id" class="read-more">{{$t("OrtakKullanim.ReadMore")}} &#8594;</a>
                                </div>
                            </div>
                          </div>
                    </div>               
                </div>
            </div>
        </div>

      <b-modal
        v-model="showNoticesModal"
        size="xl"
        centered
        title="Aktif Duyurular"
        hide-footer
      >
        <div v-for="item in ActiveNotices" :key="item.Id" class="mb-4 border-bottom pb-3">
          <h5>{{ item.Title }}</h5>
          <br>
          <p class="text-muted">
            {{ item.Startdate | formatDateTime }}
          </p>

          <img
            v-if="item.Imagegallery"
            :src="$config.FILES_URL + 'web/' + item.Imagegallery"
            class="img-fluid mb-2"
          />

          <div v-html="item.Description"></div>

          <div class="text-end mt-2">
            <a
              :href="'/NewsDetail/tr/' + item.Title.toLowerCase()
                .replace(/I|İ/gi, 'i')
                .replace(/Ğ|ğ/gi, 'g')
                .replace(/Ç|ç/gi, 'c')
                .replace(/\s+/g, '-')
                .replace(/&/g, '-and-')
                .replace(/--/g, '-') + '/' + item.Id"
              class="btn btn-sm btn-outline-primary"
            >
              Devamını Oku →
            </a>
          </div>
        </div>
      </b-modal>


    </section>

    
</template>
